import React from 'react';
// eslint-disable-next-line you-dont-need-lodash-underscore/get
import get from 'lodash/get';
import { getNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';

import { useCurrentPathContext } from '../../components';

import { isValidValue, hasValue } from './helpers';
import type { TProps } from './models';

/**
 * Условное отображение
 * */
export const ConditionalDisplay = ({
    addPath,
    children,
    maxValue,
    minValue,
    path,
    data = {},
}: TProps) => {
    const { currentPath } = useCurrentPathContext();
    const fullPath = path ? path : addPath ? `${currentPath}.${addPath}` : currentPath;
    const value = fullPath ? get(data, fullPath) : data;

    const { children: childrenSlot, noValueSlot } = getNamedContainersWithChildren(children);

    let shouldRender = hasValue(value);

    if (Array.isArray(value) || typeof value === 'number') {
        shouldRender = isValidValue({
            maxValue,
            minValue,
            value: Array.isArray(value) ? value.length : Number(value),
        });
    }

    if (shouldRender) {
        return <>{childrenSlot}</>;
    }

    return noValueSlot ? <>{noValueSlot}</> : null;
};
